import React from 'react';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const WidgetOptionGroupPermissions = ({ event, handleGroupChange, targetKeys }) => {
	return (
		<>
			<h4 className="admin-form-item-label">Group Permissions</h4>
			<div className="groups-picker">
				<EventGroupsPicker event={event} handleChange={handleGroupChange} targetKeys={targetKeys} />
			</div>
		</>
	);
};

export default WidgetOptionGroupPermissions;
